/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...
// scroll処理
let className = '.animation';
let scrollShow = function(classname){
    const targetElement = document.querySelectorAll(this.name);
    for(let i = 0; i < targetElement.length; i++){
        const getElementDistance = targetElement[i].getBoundingClientRect().top;
        if(window.innerHeight > getElementDistance){
            targetElement[i].classList.add('active');
        }
        console.log(getElementDistance);
    }
}

document.addEventListener('scroll',{name:className ,handleEvent:scrollShow});


var href = location.href;
var observer = new MutationObserver(function(mutations) {
  if(href !== location.href) {
    window.location.reload();
    href = location.href;
  }
});

observer.observe(document, { childList: true, subtree: true });